import { signParams } from '@yqz/base';
import axios  from 'axios';
import qs from 'qs';                                        

const instance = axios.create({
  baseURL: process.env.REACT_APP_BINGO_INFO_COLLECT,
  timeout: 8000,
  paramsSerializer: function (params) {
    const p = signParams({ ...params,pl_user: 'react_worker' }, process.env.REACT_APP_SECRET || '');
    return qs.stringify(p, { arrayFormat: 'repeat' });
  }
});

export default instance;